import React, { useState } from 'react';
import StripeCheckout from '@/components/StripeCheckout/StripeCheckout';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import CheckoutScreen from '@/components/Checkout/CheckoutScreen';
import LoadingOverlay from '@/components/LoadingOverlay/LoadingOverlay';
import axios from 'axios';
import { PAYPAL_CLIENT_ID } from '@/lib/defaults';
import { useRouter } from 'next/router';
import Image from 'next/legacy/image';
import { Layout } from '@/components/Layout';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { buildPublicSeoProps, PUBLIC_SITE_ORIGIN } from '@/lib/public-site-policy';

const Checkout = () => {
    const router = useRouter();
    const { email } = router.query;

    const [isLoading, setLoading] = useState(false);
    const seoProps = buildPublicSeoProps(PUBLIC_SITE_ORIGIN, '/summer-slide-checkout', {
        title: 'Checkout | Muzology',
        description: '',
    });

    const testimonial = {
        text: (
            <div>
                <span className='font-semibold'>Muzology was a game changer for my son.</span> The music videos helped him learn and remember. Finally, math is
                not the enemy!
            </div>
        ),
        name: 'Susie L, Parent and psychologist (Miami, FL)'
    };

    return (
        <Layout hideNavbar={true} hideFooter={true}>
            <NextSeo {...seoProps} />
            <Head>
                <meta name='keywords' content='' />
            </Head>

            <PayPalScriptProvider
                options={{
                    clientId: PAYPAL_CLIENT_ID,
                    intent: 'subscription', // Use 'capture' for immediate payment or 'authorize' if you want to capture the payment later
                    vault: true, // Saving payment details to the vault is not needed for one-time payments
                    components: 'buttons',
                    currency: 'USD'
                }}
            >
                <div className='h-screen pt-0 sm:pt-5 py-0 sm:py-5 lg:px-5 xl:px-8 overflow-y-auto relative'>
                    <div className=' absolute inset-0 bg-none  md:bg-checkout-timestables-background bg-cover sm:min-h-[1250px]'>
                        <div className='max-w-[1300px] mx-auto mt-0 sm:mt-20 sm:px-5 '>
                            <CheckoutScreen
                                key='checkout'
                                testimonial={testimonial}
                                // awardImages={components[0].gallery.slice(0, 2)}
                                subHeader=''
                                text=''
                                title='Your Child’s Math Success Starts Now!'
                                activeTab={1}
                                timesTables={false}
                            >
                                <LoadingOverlay show={isLoading} className='z-50 bg-red-300' style={{ background: '#00000060' }} />
                                <div className='flex flex-col gap-4 text-black '>
                                    <StripeCheckout
                                        id='stripe-checkout'
                                        sessionId={null}
                                        token={null}
                                        initialEmail={email as string || ''}
                                        initialName=''
                                        showPlanButtons={true}
                                        teacher={false}
                                        accountId={null}
                                        selectedParentPlan={3}
                                        timesTables={false}
                                        // setLoading={setLoading}
                                        // isLoading={isLoading}
                                    />
                                </div>
                            </CheckoutScreen>
                        </div>
                    </div>
                </div>
            </PayPalScriptProvider>
        </Layout>
    );
};

export default Checkout;
